<template>
    <CRow>
        <CCol col>
            <div style="width:100%; height: 75vh;">
                <ejs-grid ref='gridcc' :dataSource="ccData" :allowFiltering='true' :allowPaging="true" :allowResizing='true' :toolbarClick='toolbarClick'
                          :allowExcelExport='true' :excelExportComplete='excelExportComplete' :allowReordering='true' :enablePersistence ="true"
                          :allowSorting='true' :editSettings='editSettings' :toolbar='toolbar' :pageSettings='pageSettings' :actionBegin="actionBegin"
                          :actionComplete='actionComplete' :actionFailure="actionFailure" :filterSettings='filterOptions' width="100%" height="100%">
                    <e-columns>
                        <e-column field='id' headerText='Id' width=120 :isPrimaryKey='true' :visible='false'></e-column>
                        <e-column field='code' headerText='Conversion Identifier' :validationRules="codeRules" width=120></e-column>
                        <e-column field='currencyIdFrom' headerText='Currency From' :validationRules="requiredRules" textAlign='Right' foreignKeyField="currencyId" foreignKeyValue='name' :dataSource='currencies' editType='dropdownedit' :edit='currencyFromParams' width=90></e-column>
                        <e-column field='currencyIdTo' headerText='Currency To' textAlign='Right' :validationRules="requiredRules" foreignKeyField="currencyId" foreignKeyValue='name' :dataSource='currencies' editType='dropdownedit' :edit='currencyToParams' width=90></e-column>
                        <e-column field='providerType'
                                  headerText='Provider Type'
                                  :validationRules="requiredRules"
                                  width=180
                                  :edit='providerTypeParams'
                                  foreignKeyField='id'
                                  foreignKeyValue='name'
                                  :dataSource='providerType'
                                  editType='dropdownedit'>
                        </e-column>

                    </e-columns>
                </ejs-grid>
            </div>
        </CCol>
    </CRow>
</template>
<script>
    import Vue from "vue";
    import { GridPlugin, Edit, Page, Toolbar, Sort, Filter, Reorder, Resize, ExcelExport, ForeignKey } from "@syncfusion/ej2-vue-grids";
    import { Query } from '@syncfusion/ej2-data';
    import { createSpinner, showSpinner, hideSpinner } from '@syncfusion/ej2-popups';
    import { DropDownList, DropDownListPlugin } from "@syncfusion/ej2-dropdowns";
    import { UploaderPlugin } from '@syncfusion/ej2-vue-inputs';
    import { DialogUtility } from '@syncfusion/ej2-popups';
    import SyncHelper from '../../../common/syncfusion';
    import gridOptions from '../../../common/gridOptions'
    import store from '../../../store';
    Vue.use(UploaderPlugin);
    Vue.use(DialogUtility);

    Vue.use(GridPlugin);

    
    let currencies = SyncHelper.getDataManager('Utils/currencies');
   
    let currencyFromElem, currencyToElem, currencyFromObj, currencyToObj, providerTypeElem, providerTypeObj
    export default {
        components: {
        },
        data() {
            return {
                store: store,
                currencies: currencies,
                ccData: SyncHelper.getDataManager("CurrencyConversions"),
                providerType: SyncHelper.getDataManager("utils/providerType"),
                currencyFromParams: {
                    create: () => {
                        currencyFromElem = document.createElement('input');
                        return currencyFromElem;
                    },
                    read: () => {
                        return currencyFromObj.value;
                    },
                    destroy: () => {
                        currencyFromObj.destroy();
                    },
                    write: (args) => {
                        currencyFromObj = new DropDownList({
                            dataSource: currencies,
                            fields: { text: args.column.foreignKeyValue, value: args.column.foreignKeyField },
                            value: ((args.foreignKeyData && args.foreignKeyData[0]) ? args.foreignKeyData[0][args.column.foreignKeyField] : null),
                            change: () => {
                                currencyToObj.enabled = true;
                                let tempQuery = new Query().where('currencyId', 'notEqual', currencyFromObj.value);
                                currencyToObj.query = tempQuery;
                                currencyToObj.text = null;
                                currencyToObj.dataBind();
                            },
                            placeholder: 'Currency From',
                            floatLabelType: 'Always',
                            allowFiltering: true,
                            showClearButton: true,
                            cssClass: 'required-input',
                        });

                        currencyFromObj.appendTo(currencyFromElem);
                    }
                },
                currencyToParams: {
                    create: () => {
                        currencyToElem = document.createElement('input');
                        return currencyToElem;
                    },
                    read: () => {
                        return currencyToObj.value;
                    },
                    destroy: () => {
                        currencyToObj.destroy();
                    },
                    write: function (args) {
                        currencyToObj = new DropDownList({
                            dataSource: currencies,
                            fields: { text: args.column.foreignKeyValue, value: args.column.foreignKeyField },
                            value: ((args.foreignKeyData && args.foreignKeyData[0]) ? args.foreignKeyData[0][args.column.foreignKeyField] : null),
                            enabled: (args.foreignKeyData ? true : false),
                            placeholder: 'Currency To',
                            floatLabelType: 'Always',
                            allowFiltering: true,
                            showClearButton: true,
                            cssClass: 'required-input',
                        });
                        currencyToObj.appendTo(currencyToElem);
                    }
                },
                providerTypeParams: {
                    create: () => {
                        providerTypeElem = document.createElement('input');
                        return providerTypeElem;
                    },
                    read: () => {
                        return providerTypeObj.value;
                    },
                    destroy: () => {
                        providerTypeObj.destroy();
                    },
                    write: (args) => {
                        providerTypeObj = new DropDownList({
                            dataSource: this.providerType,
                            fields: { text: args.column.foreignKeyValue, value: args.column.foreignKeyField },
                            value: ((args.foreignKeyData && args.foreignKeyData[0]) ? args.foreignKeyData[0][args.column.foreignKeyField] : null),
                            placeholder: 'Provider Type',
                            floatLabelType: 'Always',
                            allowFiltering: false,
                            showClearButton: true,
                            cssClass: 'required-input',
                        });
                        providerTypeObj.appendTo(providerTypeElem);
                    }
                },
                pageSettings: gridOptions.pageSettings,
                editSettings: {
                    showConfirmDialog: true,
                    showDeleteConfirmDialog: true,
                    allowEditing: store.state.permissions["Permissions.CurrencyConversion.Update"],
                    allowAdding: store.state.permissions["Permissions.CurrencyConversion.Create"],
                    allowDeleting: store.state.permissions["Permissions.CurrencyConversion.Delete"],
                    mode: 'Dialog'
                },
                toolbar: ['Add', 'Edit', 'Delete', 'ExcelExport'],
                requiredRules: { required: true },
                codeRules: { required: true, maxLength: 50 },
                editparams: { params: { popupHeight: '300px' } },
                filterOptions: gridOptions.filterSettings
            };
        },
        mounted() {
            createSpinner({
                target: document.getElementById('mainSpinner'),
                width: '50',
                type: 'Material',
                label: 'Loading data...',
                cssClass: 'loadingPoup'
            });
        },
        methods: {
            toolbarClick(args) {
                gridOptions.excelExport(args, "Currency Conversions.xlsx", this.$refs);
            },
            excelExportComplete(args) {
                this.$refs.gridcc.hideSpinner();
            },
            actionBegin(args) {

                if ((args.requestType === 'beginEdit' || args.requestType === 'add')) {
                    for (var i = 0; i < this.$refs.gridcc.getColumns().length; i++) {

                    }
                }
                if (args.requestType == 'save') {

                    showSpinner(document.getElementById('mainSpinner'));


                }

                if (args.requestType == 'refresh') {

                    hideSpinner(document.getElementById('mainSpinner'));

                }
            },
            actionComplete(args) {
                gridOptions.actionComplete(args, this.$refs);
                if ((args.requestType === 'beginEdit' || args.requestType === 'add')) {
                    const arrayFields = ["code"]
                    arrayFields.forEach(function (item) {
                        let inputElement = args.form.elements.namedItem(item);
                        if (inputElement) {
                            let parentDiv = inputElement.closest('.e-input-group');
                            if (parentDiv) {
                                parentDiv.classList.add('required-input');
                            }
                        }
                    });
                }

            },
           
            actionFailure(args) {
                gridOptions.actionFailure(args);
                hideSpinner(document.getElementById('mainSpinner'));
            },
        },

        provide: {
            grid: [Page, Edit, Toolbar, Sort, Filter, Reorder, Resize, ExcelExport, ForeignKey]
        }
    };

</script>
<style>
</style>
